module.exports = __webpack_public_path__ + "static/media/employment.720919b1.svg";